import React from 'react'
import { observable, action } from 'mobx'
import localforage from 'localforage'
import errorStore from './errorStore'
import api from '../api'

class TranslationStore {
  @observable translations = []
  @observable error = undefined
  @observable inProgress = true

  constructor() {
    localforage.getItem('EPTranslations')
    .then(
      action('fetch translations locally', storedTranslations => {
        this.translations = storedTranslations
    }))
    .finally(action('fetch translations locally completed', () => {
      this.inProgress = false
    }))

    this.fetchTranslations()
  }

  @action fetchTranslations() {
    return api.Translations.getAll()
    .then(action('fetch translations' ,(translations) => {
      this.translations = translations
      localforage.setItem('EPTranslations', translations)
    }))
    .catch(action('error fetching translations' ,(err) => {
      this.errors = err.response && err.response.body && err.response.body.errors
      errorStore.displayError('No translations availible.')
    }))
    .finally(action('fetch translations completed', () => {
      this.inProgress = false
    }))
  }

  translate(key, replacements) {

    if(!this.translations) {
      return key
    }

    const translation = this.translations.find(translation => translation.key === key)

    if (!translation) {
      if(key) {
          api.Translations.missingTranslation(key)
      }
      return key
    }

    let value = translation.value

    if (replacements) {
      replacements.forEach(replacement => {
        if (replacement.html) {
          const string = value.replace(`{{${replacement.key}}}`, replacement.value)
          const d = React.createElement('div', {
            dangerouslySetInnerHTML: {
              __html: string
            }
          })
          value = d
        } else {
          value = value.replace(`{{${replacement.key}}}`, replacement.value)
        }
      })
    }

    return value
  }
}

export default new TranslationStore()



// WEBPACK FOOTER //
// ./src/stores/translationStore.js